// How the shared actions (src/features/<area>/) talk to a person on a PHONE: the same questions as
// the desktop's features/queue/desktopUi.js, shown as full-screen panels (plan rule 3: phone
// screens never call window.alert / confirm / prompt). Layout only: the words come from the action.
import pinPrompt from "../../utils/pinPrompt";
import causePrompt from "../../utils/causePrompt";
import { askTypedMinutesAsync } from "../../utils/tmAutoComplete";
import { remakeHoldChoice, remakeHeadsUp } from "../../components/RemakeDialogs.jsx";
import stickLotPrompt from "../../utils/stickLotPrompt";
import { phoneAlert, phoneAsk, phoneConfirm, phonePrompt } from "./dialogs.jsx";

// A whole-number default (a quantity) gets the number keypad.
const keypadFor = (defaultValue) => (/^\d+$/.test(String(defaultValue ?? "")) ? "numeric" : undefined);

export const phoneUi = Object.freeze({
  pin: (message, opts) => pinPrompt(message, opts),
  alert: (message) => phoneAlert(message),
  confirm: (message, opts) => phoneConfirm(message, opts),
  // Yes / no / backed out (null). The desktop has none: its window.confirm can't be closed without
  // an answer, so a shared action asks ui.ask when there is one and ui.confirm otherwise.
  ask: (message, opts) => phoneAsk(message, opts),
  prompt: (message, defaultValue) => phonePrompt(message, defaultValue ?? "", { inputMode: keypadFor(defaultValue) }),
  causePrompt: (opts) => causePrompt(opts),
  remakeHoldChoice: (hold) => remakeHoldChoice(hold),
  remakeHeadsUp: (preview, opts) => remakeHeadsUp(preview, opts),
  askTypedMinutes: (detail) => askTypedMinutesAsync(detail, (msg, def) => phonePrompt(msg, def, { inputMode: "decimal" })),
  stickLots: (state) => stickLotPrompt(state),
  // Laser Start: the sales-order pallets and their beacons (the same popup as the desktop).
  palletBeacons: (opts) => import("../../utils/palletBeaconsPrompt").then((m) => m.default(opts)),
  // Reports and routing slips print at the station; a phone shows nothing (plan, open question 3).
  openPdf: null,
  // No new tab after an await on a phone: Sales Order actions return the PDF for the screen to offer.
  openPdfTab: null,
});
